import React from 'react';
import { HealthSummaryResponseElement } from '../../../types/apiGeneratedTypes';
import TableRowActionMenu from '../../BaseComponents/TableRowActionMenu';
import './SummaryTab.scss';
import { useDispatch } from 'react-redux';
import {
  changeHealthSummaryModalVisibility,
  setHealthSummaryDataToEdit,
  setHealthSummaryIdToEdit,
} from '../../../store/memberSlice';

type SummaryListTableRowProps = {
  summaryData: HealthSummaryResponseElement;
};

const SummaryListTableRow: React.FC<SummaryListTableRowProps> = ({
  summaryData,
}) => {
  const dispatch = useDispatch();
  const onOptionClick = (id: number) => {
    dispatch(setHealthSummaryIdToEdit(id));
    dispatch(setHealthSummaryDataToEdit(summaryData));
    return dispatch(changeHealthSummaryModalVisibility(true));
  };
  return (
    <div className='table-row'>
      <div className='body-system'>{summaryData.body_system.title}</div>
      <div className='health-note'>{summaryData.details}</div>
      <div className='actions'>
        <TableRowActionMenu
          options={[
            { key: 'edit', value: 'Edit' },
            // { key: 'delete', value: 'Delete' },
          ]}
          id={summaryData.id}
          onActionMenuClick={onOptionClick}
        />
      </div>
    </div>
  );
};
export default SummaryListTableRow;
